import Vue from 'vue'
import Main from './main.vue'
import { LEAVE_ROLE, TAB_ROLE_ID, TOP_ROLE_ID } from '@/utils/constUtils'
import { getItem } from '@/utils/comUtils'
const MConstructor = Vue.extend(Main) // 直接将Vue组件作为Vue.extend的参数

let MInstance = null
/**
 * 登录窗口
 * @param {object} options 配置
 */
const PadBook = options => {
  return new Promise((resolve, reject) => {
    if (typeof options !== 'object') {
      reject(new Error('参数错误'))
      return
    }
    let _options = {
      initTreeId: options.initTreeId || {},
      treeIds: options.treeIds || {},
      treeId: options.treeId || '',
      onlyThisCampus: options.onlyThisCampus || false,
      corpName: options.corpName || '',
      campusId: options.campusId || '',
      deviceMode: options.deviceMode || 2,
      deviceSn: options.deviceSn || '',
      needReturn: options.needReturn || false, // 直接退出是否需要返回
      removeDelay: options.removeDelay || 0, // 是否延时去除dom
      classCount: options.classCount || 0, // 已选择班级数
      operUserRoleTypes: options.operUserRoleTypes || '' // 角色
    }
    if (
      _options.operUserRoleTypes &&
      _options.operUserRoleTypes === LEAVE_ROLE.classTeacher
    ) {
      let { role } = getItem(TAB_ROLE_ID) || {}
      if (!role) {
        let _topRole = getItem(TOP_ROLE_ID)
        let _roleIdList = getItem('roleIdList')
        role = _topRole || (_roleIdList && _roleIdList[0])
      }
      _options.role = role
    }
    // eslint-disable-next-line space-before-function-paren
    _options.close = function (result) {
      let _params = {
        removeDelay: _options.removeDelay
      }
      PadBook.close(_params)
        .then(res => {
          resolve(result)
        })
        .catch(err => {
          reject(err)
        })
    }
    // eslint-disable-next-line space-before-function-paren
    _options.closeOnly = function () {
      let _params = {
        removeDelay: _options.removeDelay
      }
      PadBook.close(_params)
        .then(res => {
          resolve({
            $type: this.needReturn ? 'onlyReturn' : '',
            treeIds: this.treeIds
          })
        })
        .catch(err => {
          reject(err)
        })
    }
    MInstance = new MConstructor({ data: _options })

    MInstance.vm = MInstance.$mount() // 挂载但是并未插入dom，是一个完整的Vue实例
    MInstance.dom = MInstance.vm.$el
    if (!_options.appendNode) {
      document.body.appendChild(MInstance.dom) // 将dom插入body
    } else {
      document.getElementById('app').appendChild(MInstance.dom)
    }

    MInstance.vm.visible = true
  })
}

// eslint-disable-next-line
PadBook.close = function () {
  return new Promise((resolve, reject) => {
    if (MInstance) {
      // //销毁vm实例与DOM之间的关联
      MInstance.vm.$destroy()
      window.history.go(-1)
      // 防止返回后通讯录一直盖在界面上没有消失
      let $addressDom = MInstance.dom
      $addressDom && $addressDom.remove()
      MInstance = null
    } else {
      let $addressDom = document.getElementById('$addresss-book$')
      $addressDom && $addressDom.remove()
    }
    resolve()
  })
}

export default PadBook
